<div *ngIf="showSubs" id="subFolders">
    <p-panel header="Subfolders" [toggleable]="true" >
        <ng-template pTemplate="body">
            <div class="subfolder-grid">
                <div *ngFor="let sub of subFolders" style="width: 100%;cursor: pointer;" class="px-4 pb-2">
                    <i class="pi pi-folder" style="margin-right: 0.5rem;"></i>
                    <a (click)="onFolderClick(sub.path);">{{sub.name}}</a>
                </div>
            </div>
        </ng-template>
    </p-panel>
</div>